export default {
  '确认要修改为噪音?': '确认要修改为噪音?',
  '批量选择的范围内，待插入心搏与相邻心搏RR间期小于200毫秒的数量为  {length}，建议跳过这些位置的心搏插入操作。':
    '批量选择的范围内，待插入心搏与相邻心搏RR间期小于200毫秒的数量为  {length}，建议跳过这些位置的心搏插入操作。',
};
